import { cn } from "@newxsystems/shared";
import { VelvetAction } from "../VelvetAction/VelvetAction";
import { VelvetRichText } from "../VelvetRichText/VelvetRichText";
import type { IVelvetCommonContentProps } from "./VelvetCommonContent.props";

export const VelvetCommonContent = ({
  alignment,
  buttons,
  className,
  description,
  eyebrow,
  heading,
  headingAs = "h2",
  headingClassName,
  tone = "light",
}: IVelvetCommonContentProps) => {
  if (!eyebrow && !heading && !description && !buttons?.length) return null;

  const Heading = headingAs;
  const centered = alignment === "center";
  const actions = buttons;

  return (
    <div
      className={cn(
        "flex max-w-[58rem] flex-col gap-5 border-t border-parchment/20 pt-5",
        centered && "mx-auto items-center text-center",
        className,
      )}
    >
      {eyebrow ? (
        <p
          className={cn(
            "velvet-datum w-fit font-velvet-body text-base italic leading-none text-thread",
            tone === "dark" && "text-parchment",
          )}
        >
          {eyebrow}
        </p>
      ) : null}
      {heading ? (
        <Heading
          className={cn(
            "max-w-[15ch] font-velvet-display text-5xl font-black uppercase leading-[0.84] tracking-[-0.04em] text-balance text-foreground [overflow-wrap:anywhere] md:text-7xl",
            tone === "dark" && "text-parchment",
            headingClassName,
          )}
        >
          {heading}
        </Heading>
      ) : null}
      {description ? (
        <VelvetRichText
          className={cn(
            "max-w-[65ch]",
            tone === "dark" &&
              "text-parchment [&_a]:text-parchment [&_blockquote]:border-parchment/40 [&_blockquote]:text-parchment",
          )}
          content={description}
        />
      ) : null}
      {actions?.length ? (
        <div className={cn("flex flex-wrap gap-x-6 gap-y-3 pt-4", centered && "justify-center")}>
          {actions.map((button, index) => (
            <VelvetAction
              action={button}
              className={tone === "dark" ? "border-bone" : undefined}
              key={`${button.href}-${index}`}
            />
          ))}
        </div>
      ) : null}
    </div>
  );
};

VelvetCommonContent.displayName = "Content::VelvetCommonContent";
